import { User } from "../@core/data/users";

export class Purchase {
  id?: string;

  //ref trade
  receiptId?: string;
  refCustomerId?: string;
  refCustomerName?: string;

  //purchase
  issueDate?: Date;
  issueDateSeconds?: number;
  issueDateMinutes?: number;
  issueDateHours?: number;
  issueDateDay?: number; //day of the month
  issueDateMonth?: number;
  issueDateYear?: number;
  issueDateWeekDay?: number; //the day of the week, Sunday=0 - Saturday=6

  code?: string;
  warehouseId?: string;
  userId?: string;
  note?: string;
  tags?: string[];

  totalDiscountAmount?: number;
  detailDiscountAmount?: number;
  discountAmount?: number;
  discountPercent?: number;
  detailAmount?: number;
  detailNetAmount?: number;
  totalQuantity?: number;
  totalAmount?: number;
  vatPercent?: number;
  vatAmount?: number;

  isCancel?: boolean;
  isClosed?: boolean;
  isPrint?: boolean;
  status?: string;
  noPrint?: number;

  //supplier - membership
  membershipCardId?: string;
  membershipTypeName?: string;
  supplierId?: string;
  // supplier?: Customer;
  supplierName?: string;
  supplierMobile?: string;
  supplierAddress?: string;

  //Receive-Delivery
  employeeReceiveId?: string;
  employeeReceiveName?: string;

  deliveryDate?: Date;
  employeeDeliveryId?: string;
  deliveryNote?: string;

  //Cashier
  cashierName?: string;
  isTrade?: boolean;

  //payment
  isCash?: boolean;
  paymentAmount?: number;
  paymentRefund?: number;
  //payment detail
  paymentDate?: Date;
  isDebit?: boolean;
  paymentDebit?: number;
  paymentPaidType?: string; //Cash/Visa/Point/Voucher
  paymentPaidPoint?: number;
  paymentPaidVisa?: number;
  paymentPaidCash?: number;
  paymentPaidVoucher?: number;

  //detail
  purchaseDetails?: PurchaseDetail[];
  isDetailChanged?: boolean;

  //inventory
  isInventory?: boolean;
  IssueDateInventory?: Date;

  //default
  shopId?: string;
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  companyId?: string;
}

export class PurchaseDetail {
  id?: string;
  purchaseId?: string;
  productInventoryId?: string;

  productId?: string;
  productCode: string;
  productName: string;
  productDescription: string;
  productUnitName: string;
  productCostPrice: number;

  discountPercent: number;
  discountAmount: number;
  quantity: number;
  price: number;
  salePrice: number;
  amount: number;
  netAmount: number;
  comment: string;

  timestamp?: number;
  isDeleted?: boolean;
  isActive?: boolean;
}
